module.exports = __webpack_public_path__ + "fonts/dm-sans-v15-latin-600.woff2";